import { Brand, createBranded } from '@deltasierra/type-utilities';

export type StripeChargeId = Brand<number, 'StripeChargeId'>;
export const StripeChargeId = createBranded<StripeChargeId>();